<template>
  <div>
    <b-card>
      <page-title v-if="titleStatus" :title="$t('systemWallets.items')" />

      <main-table
        :fields="fields"
        :list_url="'admin/system-wallet'"
        :reloadData="reloadData"
        :params="filter"
        :createStatus="false"
        :excelFields="excelFields"
        excelName="systemWallets"
      />
    </b-card>
  </div>
</template>
<script>
import { core } from "../../../../config/pluginInit";
import SystemWalletFilter from "../models/SystemWalletFilter";
import searchMixin from "../../../../Mixins/searchMixin";

export default {
  mixins: [searchMixin],
  data() {
    return {
      filter: new SystemWalletFilter(),
      fields: [
        this.$t("global.selected"),
        { key: "id", label: this.$t("table.id"), sortable: true },
        { key: "amount", label: this.$t("global.amount"), sortable: true },
        { key: "name", label: this.$t("table.name"), sortable: true },
        {
          key: "actions",
          label: this.$t("table.actions"),
          type: "actions",
          actions: [
            {
              text: this.$t("global.view"),
              icon: "fas fa-eye",
              color: "info",
              ifNavigate: true,
              routeName: "transactions.systemWalletView",
              routeParams: ["id"],
            },
          ],
        },
      ],
      excelFields: {
        [this.$t("table.id")]: "id",
        [this.$t("global.amount")]: "amount",
        [this.$t("table.name")]: "name",
        [this.$t("table.createdAt")]: "created_at",
      },
    };
  },
  mounted() {
    core.index();
  },
};
</script>
